import React, { useState } from "react";
import ArrowDown from "../img/ArrowDown.svg";
import User from "../img/User.svg";
import { useNavigate } from "react-router-dom";
import Sort from "../img/Sort.svg";

const AppHomeDetailsHeader = () => {
  const navigate = useNavigate();

  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // State for toggling the mobile menu

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const handleClickSignUp = () => {
    navigate("/SignUp"); // replace with your actual route
  };

  const handleClickSignIn = () => {
    navigate("/Login"); // replace with your actual route
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen); // Toggle the mobile menu
  };

  return (
    <div className="w-full h-16 flex items-center justify-between px-5 bg-[#4C3A68]  shadow-[#8C62E280]">
      {/* Left Section: Logo */}
      <div className="flex">
        <span
          className="font-bold text-2xl text-white cursor-pointer"
          onClick={() => navigate("/")}
        >
          {" "}
          Onzitr Marketplace
        </span>
      </div>

      {/* Hamburger Menu Icon (visible on small screens) */}
      <div className="sm:hidden flex items-center">
        <button
          onClick={toggleMobileMenu}
          className="text-white focus:outline-none"
        >
          <img src={Sort} alt="Hamburger Menu" className="w-6 h-6" />
        </button>
      </div>

      {/* Desktop Menu (visible on larger screens) */}

      {/* Desktop Buttons */}
      <div className="hidden sm:flex gap-2 items-center">
        <span
          className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl"
          onClick={handleClickSignIn}
          style={{
            border: "0.5px solid #A8A8A8",
            backgroundColor: "#FFFFFF",
            color: "#9367D7",
            borderImageSlice: 1,
            boxShadow: "0px 4px 4px 0px #00000040",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
          }}
        >
          Sign in
        </span>

        <span
          className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl"
          onClick={handleClickSignUp}
          style={{
            border: "0.5px solid #A8A8A8",
            background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
            color: "#FFFFFF",
            borderImageSlice: 1,
            boxShadow: "0px 4px 4px 0px #00000040",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
          }}
        >
          Sign up
        </span>
      </div>

      {/* Mobile Menu (visible on small screens) */}
      <div
        className={`${
          isMobileMenuOpen ? "block" : "hidden"
        } sm:hidden absolute top-16 left-0 w-full bg-[#4C3A68] text-white p-5 shadow-md`}
      >
        <div className="flex flex-col gap-4">
          {/* Features Dropdown */}

          {/* Pricing */}

          {/* Customers */}

          {/* Resource Dropdown */}

          {/* Mobile Buttons */}
          <div className="flex gap-2 items-center mt-4">
            <span
              className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl"
              onClick={handleClickSignUp}
              style={{
                border: "0.5px solid #A8A8A8",
                backgroundColor: "#FFFFFF",
                color: "#9367D7",
                borderImageSlice: 1,
                boxShadow: "0px 4px 4px 0px #00000040",
                backdropFilter: "blur(1px)",
                WebkitBackdropFilter: "blur(1px)",
              }}
            >
              Sign in
            </span>

            <span
              className="cursor-pointer text-sm font-bold text-white px-3 py-1 rounded-2xl"
              onClick={handleClickSignUp}
              style={{
                border: "0.5px solid #A8A8A8",
                background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                color: "#FFFFFF",
                borderImageSlice: 1,
                boxShadow: "0px 4px 4px 0px #00000040",
                backdropFilter: "blur(1px)",
                WebkitBackdropFilter: "blur(1px)",
              }}
            >
              Sign up now
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppHomeDetailsHeader;
